import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Notification } from '@thiememeulenhoff/types';
import { NotificationEndpointService } from './notification.endpoint.service';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  readonly #http = inject(HttpClient);

  readonly #endpoints = inject(NotificationEndpointService);

  fetchNotifications(methodSlug: string | null = null) {
    const endpoint = methodSlug
      ? this.#endpoints.getNotificationsForMethod(methodSlug)
      : this.#endpoints.getNotifications();

    return this.#http.get<Array<Notification>>(endpoint);
  }

  postNotificationSeen(notificationId: number) {
    return this.#http.post(
      this.#endpoints.getNotificationSeen(notificationId),
      {},
    );
  }

  postNotificationAllSeen(methodSlug: string, untilNotificationId: number) {
    return this.#http.post(
      this.#endpoints.getNotificationAllSeen(methodSlug, untilNotificationId),
      {},
    );
  }

  deleteNotification(notificationId: number) {
    return this.#http.delete(
      this.#endpoints.getnotificationDelete(notificationId),
    );
  }
}
